/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function nielsenTemplatesEditViewController(this: JS5Object, _: JS5Object, $routeParams: JS5Object, $route: JS5Object,
                                            $location: JS5Object, PartnerEditService: JS5Object, uiGridConstants: JS5Object,
                                            ModalService: JS5Object, NotificationService: JS5Object,
                                            MediaAcceptProfileService: JS5Object, BreadcrumbService: JS5Object,
                                            UtilsService: JS5Object, SidebarService: JS5Object, $timeout: JS5Function) {
    this.editData = {};
    const getData = () => {
        this.loadingIndicator.show = true;
        PartnerEditService.getNielsenTemplate($routeParams.nielsenTemplateId).then((nielsenTemplate: JS5Object) => {
            PartnerEditService.originalnielsenTemplateData = _.cloneDeep(nielsenTemplate);
            this.editData = nielsenTemplate;
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveHandler = () => {
        this.loadingIndicator.show = true;
        if (_.isNil(_.get(this, 'editData.data')) || _.isEmpty(_.get(this, 'editData.data'))) {
            _.set(this, 'editData.data', {});
        }
        if ($routeParams.nielsenTemplateId === '-1') {
            saveNewNielsenTemplate();
        } else {
            updateNielsenTemplate();
        }
    };

    const updateNielsenTemplate = () => {
        PartnerEditService.updateNielsenTemplate(this.editData).then((nielsenTemplate: JS5Object) => {
            PartnerEditService.originalnielsenTemplateData = _.cloneDeep(nielsenTemplate);
            this.editData = nielsenTemplate;
            this.editorForm.$setPristine();
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };

    const saveNewNielsenTemplate = () => {
        PartnerEditService.createNielsenTemplate($routeParams.id, this.editData).then((nielsenTemplate: JS5Object) => {
            this.editData = nielsenTemplate;
            $route.updateParams({nielsenTemplateId: nielsenTemplate.id});
        }).finally(() => {
            this.loadingIndicator.show = false;
        });
    };


    this.toolbarButtonDefs = [
        {
            label: 'Save',
            enabled: () => !_.get(this.editorForm, '$pristine')
                && _.size(_.get(this.editData, 'name')),
            onClick: saveHandler
        },
        {
            label: 'Revert',
            enabled: () => !_.get(this.editorForm, '$pristine'),
            onClick: () => {
                this.editData = _.cloneDeep(PartnerEditService.originalnielsenTemplateData);
                this.editorForm.$setPristine();
            }
        },
        {
            label: 'Close',
            enabled: () => !_.get(this.editorForm, '$dirty'),
            onClick: () => $location.url(`/system/partners/edit/${$routeParams.id}/nielsenTemplates`)
        }
    ];

    this.$onInit = () => {
        SidebarService.editService = PartnerEditService;
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        if ($routeParams.nielsenTemplateId !== '-1') {
            getData();
        }
        if (_.isNil(_.get(PartnerEditService, 'partnerObject'))) {
            PartnerEditService.getEditData().then(() => {
                setupBreadcrumbs();
            });
        } else {
            setupBreadcrumbs();
        }

    };

    const setupBreadcrumbs = () => {
        if ($routeParams.nielsenTemplateId !== '-1') {
            if (_.size(BreadcrumbService.getBreadcrumbs()) < 2) {
                BreadcrumbService.addBreadcrumb({
                    name: _.get(PartnerEditService, 'partnerObject.name', 'Edit Nielsen Template'),
                    location: `/system/partners/edit/${$routeParams.id}/nielsenTemplates`
                });
            }
        } else {
            this.allowNielsenTemplateTypeEdit = true;
            BreadcrumbService.addBreadcrumb({
                name: _.get(PartnerEditService, 'partnerObject.name', 'Create Nielsen Template'),
                location: `/system/partners/edit/${$routeParams.id}/nielsenTemplates`
            });
        }
    };
    this.$onDestroy = () => {
        PartnerEditService.originalnielsenTemplateData = null;
        PartnerEditService.viewData = null;
    };

    this.$postLink = () => {
        $timeout(() => {
            PartnerEditService.editorForm = this.editorForm;
            BreadcrumbService.editService = PartnerEditService;
        });
    };
}


angular.module('prism-ui.nielsenTemplates').component('nielsenTemplatesEditView', {
    templateUrl: 'system/partner/editor/components/view/nielsenTemplates/editor/nielsen-templates-edit-view-template.html',
    controller: nielsenTemplatesEditViewController
});
